module.exports = __webpack_public_path__ + "img/banner.5c1a0849.jpg";